<template>
  <div class="hero-section">
    <div class="background">
      <div class="hero-content container">
        <div
          class="hero-content-info"
          data-aos="slide-right"
          data-aos-duration="10000"
        >
          <div class="editors-choice">
            <div class="icon-style">
              <IconComponent name="checked" />
            </div>
            <p>Que tu idioma no te limite</p>
          </div>
          <h1>Programación al Alcance de todos</h1>
          <p>

          </p>
          <div class="demo-section">
            <button v-on:click="clicked('/code/edit')">Editor de Codigo</button>
            <p v-on:click="clicked('/detail')">Docs</p>
          </div>
        </div>
        <div data-aos="slide-left" data-aos-duration="10000">
          <img src="../../assets/images/app-image.jpg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconComponent from "./IconComponent";
export default {
  components: {
    IconComponent
  },
  methods: {
    clicked: function (path) {
      this.$router.push(path)
    }
  }
};
</script>
